import React, {useCallback, useEffect, useState} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import GENERATOR from "../generator/Generator";
import DownloadModal from "./DownloadModal";
import {v4 as uuidv4} from 'uuid'
import CONFIG from '../../temp/config'
import {getValidationReport} from "../../scripts/validation";
import {mygaSession} from "../../scripts/myga-session";

const DownloadButton = props => {
  const {recording} = props;
  let [showModal, setShowModal] = useState(false)
  
  useEffect(async () =>{
    if (!recording && GENERATOR.getTestActionList().length>1) {
      setShowModal(true);
    }
  },[recording]);
  
  const downloadObjectAsJson = useCallback((obj, filename) => {
    let dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(obj, null, 2))
    let downloadAnchorNode = document.createElement('a')
    downloadAnchorNode.setAttribute("href",     dataStr)
    downloadAnchorNode.setAttribute("download", filename + ".json")
    document.body.appendChild(downloadAnchorNode)
    downloadAnchorNode.click()
    downloadAnchorNode.remove()
  },[])

  const handleClick = useCallback(async () => {
    await GENERATOR.setTestModeEnabled(false)
    setShowModal(true)
  }, [])

  const handleSave = data => {
    let testCase = {...data,
      test: GENERATOR.getTestActionList(),
      validation: getValidationReport(),
      pageStack: mygaSession.getPageStack(),
      errorMessage: mygaSession.getErrorMessage()
    };
    downloadObjectAsJson(testCase, `test_v${CONFIG.testVersion}_p${data.path}_${data.testID}`)
    setShowModal(false)
  }

  return (
    <>
      <button id={'TEST_download_btn'}
              className={'toolbar-btn toolbar-download-btn'}
              onClick={handleClick}
              disabled={recording || GENERATOR.getTestActionList().length<2}>
        <FontAwesomeIcon icon={'download'} />
      </button>

      <DownloadModal show={showModal}
                     onHide={() => setShowModal(false)}
                     handleSave={handleSave}/>
    </>
  )
}

export default DownloadButton